import { useContext } from 'react'
import { RouteComponentProps } from 'react-router'
import { RouterContext } from '../Routes/CustomBrowserRouter'

export default function useRouter<T = any>() {
  return useContext(RouterContext) as RouteComponentProps<T>
}
